<template>
  <div class="d-flex flex-column justify-content-end">
    <div v-for="(choice, index) in question.choices" :key="index" class="" role="tablist" aria-orientation="vertical">
      <label
          :class="getChoiceClass(choice)"
          class="block mb-2 rounded-lg nav-link p-2 lg:p-4 w-100 flex justify-content-start align-items-start shadow cursor-pointer"
          :for="'q_choice_' + choice.id"
      >
        <input
            :disabled="!canBeSelected"
            :id="'q_choice_' + choice.id"
            v-model="isSelected"
            type="radio"
            class="mt-1 mr-2 hidden"
            name="choice"
            :value="choice.id"
        />
        <icon v-if="choice.isCorrect" class="w-5 h-5 fill-white question-icon" name="check"/>
        <i v-else-if="question.wasAnswered && isSelected === choice.id && ! choice.isCorrect" class="fa fa-times icon--wrong w-5 h-5 fill-white"></i>
        <icon v-else-if="isSelected === choice.id" class="w-5 h-5 fill-white question-icon" name="circle"/>
        <icon v-else-if="question.wasAnswered && isSelected !== choice.id && choice.is_correct" class="w-5 h-5 question-icon fill-green-600" name="circle"/>
        <icon v-else class="w-5 h-5 question-icon fill-secondary-400" name="circle"/>
        <span class="ml-2 w-100 block text-sm lg:text-base">{{ choice.text }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {

  components: {
    Icon,
  },

  props: {
    question: Object,
  },

  emits: ['update'],

  data() {
    return {
      isSelected: false,
    }
  },

  watch: {
    isSelected() {
      this.$emit('update', this.isSelected)
    },
  },

  computed: {
    canBeSelected() {
      return ! this.question.wasAnswered
    },
  },

  methods: {
    getChoiceClass(choice) {

      if( choice.is_correct && choice.isWrong ) {
        return [
          'bg-green-100 text-green-600',
        ]
      }
      if ( this.question.wasAnswered && this.isSelected === choice.id && ! choice.isCorrect ) {
        return [
          'bg-red-500 text-white',
        ]
      }
      if (choice.isCorrect || choice.isWrong) {
        return [
          {'bg-green-500 text-white': choice.isCorrect},
          {'bg-red-500 text-white': choice.isWrong},
        ]
      } else {
        return [
          this.isSelected === choice.id ? 'bg-secondary-500 text-white' : 'bg-white',
        ]
      }
    },
  },

}
</script>

<style scoped>
.bg-green-500,
.bg-red-500 {

}

.question-icon {
  min-width: 1.25rem !important;
}

.icon--wrong {
  font-size: 1.5rem;
  line-height: 100%;
  left: 3px;
  position: relative;
}
</style>
